/* Cycle Closet PDP behaviour - Sep 2026 facelift */
(function () {
  'use strict';

  function variantData() {
    var el = document.querySelector(
      'variant-radios script[type="application/json"], variant-selects script[type="application/json"]'
    );
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function currentVariant() {
    var input = document.querySelector('.product__info-container form[data-type="add-to-cart-form"] input[name="id"]');
    if (!input) input = document.querySelector('.product__info-container input[name="id"]');
    if (!input) return null;
    var id = parseInt(input.value, 10);
    var list = variantData();
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return list[i];
    }
    return null;
  }

  /* ---------- option label: show the selected value inline ---------- */
  function syncOptionLabels() {
    var variant = currentVariant();
    document.querySelectorAll('.cc-opt-value').forEach(function (span) {
      var pos = parseInt(span.getAttribute('data-option-position'), 10);
      var value = '';
      if (variant) value = variant['option' + pos] || '';
      if (!value) {
        var checked = document.querySelector(
          'variant-radios fieldset:nth-of-type(' + pos + ') input[type="radio"]:checked'
        );
        if (checked) value = checked.value;
      }
      span.textContent = value ? ': ' + value : '';
    });
  }

  /* ---------- sale badge shows the saving, not the word Sale ---------- */
  function updateSaveBadge() {
    var wrap = document.querySelector('.product__info-container .price');
    if (!wrap) return;
    var badge = wrap.querySelector('.price__badge-sale');
    var wasEl = wrap.querySelector('.price__sale s .price-item--regular');
    var nowEl = wrap.querySelector('.price__sale .price-item--sale');
    if (!badge || !wasEl || !nowEl) return;

    var parse = function (el) {
      var raw = (el.textContent || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
      return parseFloat(raw);
    };
    var was = parse(wasEl);
    var now = parse(nowEl);
    if (!isFinite(was) || !isFinite(now) || was <= now) return;

    var diff = was - now;
    var symbolMatch = (nowEl.textContent || '').match(/[^0-9\s]+/);
    var symbol = symbolMatch ? symbolMatch[0] : '$';
    var amount = Math.abs(diff % 1) < 0.005 ? diff.toFixed(0) : diff.toFixed(2);
    badge.textContent = 'Save ' + symbol + amount;
  }

  /* ---------- quantity + add to cart on one row ---------- */
  function buildBuyBoxRow() {
    var container = document.querySelector('.product__info-container');
    if (!container) return;
    if (container.querySelector('.cc-buybox-row')) return;
    var qty = container.querySelector('.product-form__quantity');
    if (!qty) return;
    var buttonsBlock = container.querySelector('.product-form');
    if (!buttonsBlock) return;
    var qtyBlock = qty.closest('[id^="Quantity-"], .product__info-container > div') || qty;
    var buyBlock = buttonsBlock.closest('.product__info-container > div') || buttonsBlock;
    if (qtyBlock === buyBlock) return;

    var row = document.createElement('div');
    row.className = 'cc-buybox-row';
    buyBlock.parentNode.insertBefore(row, qtyBlock);
    var buttonsWrap = document.createElement('div');
    buttonsWrap.className = 'cc-buybox-row__buttons';
    row.appendChild(qtyBlock);
    buttonsWrap.appendChild(buyBlock);
    row.appendChild(buttonsWrap);
  }

  /* ---------- size guide + find my size on one row ---------- */
  function buildSizeRow() {
    var sg = document.querySelector('.cc-sg');
    var find = document.querySelector('.cc-find-size');
    if (!sg || !find) return;
    if (document.querySelector('.cc-sg__row')) return;
    var sgBtn = sg.querySelector('.cc-sg__open');
    var findBtn = find.querySelector('.cc-find-size__open');
    if (!sgBtn || !findBtn) return;

    var row = document.createElement('div');
    row.className = 'cc-sg__row';
    sg.insertBefore(row, sg.firstChild);
    row.appendChild(sgBtn);
    var sep = document.createElement('span');
    sep.className = 'cc-sg__sep';
    row.appendChild(sep);
    row.appendChild(findBtn);
    find.remove();
  }

  /* ---------- stock status + dispatch cutoff ---------- */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function adelaideNow() {
    var parts = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'Australia/Adelaide', hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short'
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return {
      weekday: o.weekday,
      hour: parseInt(o.hour, 10) % 24,
      minute: parseInt(o.minute, 10)
    };
  }

  /* Per-variant stock source. cc-pdp-stock.liquid writes a map of variant id to
     'in' (stocked at Adelaide, the only pickup location) or 'ext' (available
     only via a supplier warehouse location). Falls back to the product-level
     ext-warehouse tag if the map is missing. */
  var ccStockSrc = {};
  var ccStockPending = {};

  function seedStockMap(box) {
    var mapEl = box.querySelector('script.cc-stock-map');
    if (!mapEl) return;
    try {
      var map = JSON.parse(mapEl.textContent);
      Object.keys(map).forEach(function (k) { ccStockSrc[k] = map[k]; });
    } catch (e) {}
  }

  /* Liquid can only tell whether the rendered variant is at Adelaide, so for
     any other variant re-render this section for it and read the answer
     from the returned .cc-stock-map. Cached per variant. */
  function fetchStockSrc(box, id) {
    if (ccStockPending[id]) return;
    var section = box.closest('[id^="shopify-section-"]');
    if (!section || !window.fetch) return;
    ccStockPending[id] = true;
    var sid = section.id.replace('shopify-section-', '');
    fetch(window.location.pathname + '?variant=' + id + '&section_id=' + encodeURIComponent(sid))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var mapEl = doc.querySelector('.cc-stock script.cc-stock-map');
        if (mapEl) {
          var map = JSON.parse(mapEl.textContent);
          Object.keys(map).forEach(function (k) { ccStockSrc[k] = map[k]; });
        }
        if (!ccStockSrc[id]) ccStockSrc[id] = box.getAttribute('data-ext-warehouse') === 'true' ? 'ext' : 'in';
        updateStock();
      })
      .catch(function () {})
      .then(function () { ccStockPending[id] = false; });
  }

  /* Returns true (supplier only), false (at Adelaide) or null (still looking). */
  function isSupplierOnly(box, variant) {
    if (!variant) return box.getAttribute('data-ext-warehouse') === 'true';
    var key = String(variant.id);
    if (ccStockSrc[key]) return ccStockSrc[key] === 'ext';
    fetchStockSrc(box, key);
    return null;
  }

  function updateStock() {
    var box = document.querySelector('.cc-stock');
    if (!box) return;
    var statusEl = box.querySelector('.cc-stock__status');
    var textEl = box.querySelector('.cc-stock__text');
    var dispatchEl = box.querySelector('.cc-stock__dispatch');
    var countEl = box.querySelector('.cc-stock__countdown');
    var variant = currentVariant();

    var available = variant ? variant.available : box.getAttribute('data-available') === 'true';
    var extWarehouse = isSupplierOnly(box, variant);

    if (!available) {
      statusEl.setAttribute('data-state', 'out');
      textEl.textContent = box.getAttribute('data-label-out') || 'Out of stock';
      if (dispatchEl) dispatchEl.hidden = true;
      return;
    }

    if (extWarehouse === null) {
      statusEl.setAttribute('data-state', 'in');
      textEl.textContent = 'In stock';
      if (dispatchEl) dispatchEl.hidden = true;
      return;
    }

    if (extWarehouse) {
      statusEl.setAttribute('data-state', 'backorder');
      textEl.textContent = box.getAttribute('data-label-supplier') || 'In stock at supplier warehouse';
      if (dispatchEl) dispatchEl.hidden = true;
      return;
    }

    statusEl.setAttribute('data-state', 'in');
    textEl.textContent = box.getAttribute('data-label-in') || 'In stock, ready to ship';

    if (!dispatchEl || !countEl) return;
    var cutoffHour = parseInt(box.getAttribute('data-cutoff-hour') || '14', 10);
    var now = adelaideNow();
    var weekend = now.weekday === 'Sat' || now.weekday === 'Sun';
    var minutesLeft = (cutoffHour * 60) - (now.hour * 60 + now.minute);

    if (weekend || minutesLeft <= 0) {
      dispatchEl.hidden = true;
      return;
    }
    var h = Math.floor(minutesLeft / 60);
    var m = minutesLeft % 60;
    countEl.textContent = (h > 0 ? h + 'h ' : '') + pad(m) + 'm';
    dispatchEl.hidden = false;
  }

  /* ---------- landing on a sold-out variant ----------
     Catalog ads (Meta, Google Shopping) link to one size/colour with
     ?variant=. If that variant has sold out since the feed last synced, the
     page opened on a "Sold out" button even when other sizes or colours were
     in stock. On load, if the URL names a sold-out variant, switch to the
     closest one in stock: same colour in the nearest size first, then the
     same size in another colour, then anything in stock. A short note says
     what happened; it clears as soon as the shopper picks an option. */
  var ccSwapping = false;
  var ccUserPicked = false;

  function optionFieldsets() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.product__info-container variant-radios fieldset, .product__info-container variant-selects fieldset')
    );
  }

  function sizeOptionIndex(fieldsets) {
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      var name = (legend && legend.textContent) || '';
      if (!name) {
        var input = fieldsets[i].querySelector('input, select');
        name = (input && input.name) || '';
      }
      if (/size/i.test(name)) return i;
    }
    return -1;
  }

  function pickReplacement(current, list, sizeIdx, sizeOrder) {
    var inStock = list.filter(function (v) { return v.available; });
    if (!inStock.length) return null;
    var others = function (v, skip) {
      for (var i = 0; i < v.options.length; i++) {
        if (i !== skip && v.options[i] !== current.options[i]) return false;
      }
      return true;
    };
    if (sizeIdx > -1) {
      var curPos = sizeOrder.indexOf(current.options[sizeIdx]);
      var sameColour = inStock.filter(function (v) { return others(v, sizeIdx); });
      if (sameColour.length) {
        sameColour.sort(function (a, b) {
          var da = Math.abs(sizeOrder.indexOf(a.options[sizeIdx]) - curPos);
          var db = Math.abs(sizeOrder.indexOf(b.options[sizeIdx]) - curPos);
          return da - db;
        });
        return sameColour[0];
      }
      var sameSize = inStock.filter(function (v) { return v.options[sizeIdx] === current.options[sizeIdx]; });
      if (sameSize.length) return sameSize[0];
    }
    return inStock[0];
  }

  function showSwapNote(from, to) {
    var anchor = document.querySelector('.product__info-container .cc-stock');
    if (!anchor) return;
    var old = document.querySelector('.cc-swap-note');
    if (old) old.remove();
    var note = document.createElement('p');
    note.className = 'cc-swap-note';
    note.setAttribute('role', 'status');
    note.textContent = from.options.join(' / ') + ' is sold out. Showing ' + to.options.join(' / ') + ', which is in stock.';
    anchor.parentNode.insertBefore(note, anchor);
  }

  function redirectSoldOutLanding() {
    var params = new URLSearchParams(window.location.search);
    var requested = parseInt(params.get('variant'), 10);
    if (!requested) return;
    var list = variantData();
    var current = null;
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === requested) { current = list[i]; break; }
    }
    if (!current || current.available || !current.options) return;

    var fieldsets = optionFieldsets();
    if (fieldsets.length !== current.options.length) return;
    var sizeIdx = sizeOptionIndex(fieldsets);
    var sizeOrder = [];
    if (sizeIdx > -1) {
      fieldsets[sizeIdx].querySelectorAll('input[type="radio"]').forEach(function (r) { sizeOrder.push(r.value); });
    }
    var target = pickReplacement(current, list, sizeIdx, sizeOrder);
    if (!target) return;

    showSwapNote(current, target);
    applyVariant(fieldsets, target, 1);
  }

  /* Tick the target's options and fire one change event. Dawn's handler can
     still be wiring up on a cold load, so confirm the form picked up the new
     variant and fire again if not (up to 4 tries). */
  function applyVariant(fieldsets, target, attempt) {
    var last = null;
    for (var o = 0; o < target.options.length; o++) {
      var radios = fieldsets[o].querySelectorAll('input[type="radio"]');
      for (var r = 0; r < radios.length; r++) {
        if (radios[r].value === target.options[o]) {
          radios[r].checked = true;
          last = radios[r];
          break;
        }
      }
    }
    if (!last) return;
    ccSwapping = true;
    last.dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(function () { ccSwapping = false; }, 400);
    setTimeout(function () {
      var idInput = document.querySelector('.product__info-container form[data-type="add-to-cart-form"] input[name="id"]');
      if (!ccUserPicked && idInput && String(idInput.value) !== String(target.id) && attempt < 4) {
        applyVariant(optionFieldsets(), target, attempt + 1);
      }
    }, 1200);
  }

  function refresh() {
    syncOptionLabels();
    updateSaveBadge();
    updateStock();
  }

  function init() {
    buildBuyBoxRow();
    buildSizeRow();
    var stockBox = document.querySelector('.cc-stock');
    if (stockBox) seedStockMap(stockBox);
    /* The variant change handler lives in product-info.js, which loads after
       this file, so wait for <product-info> to be defined before switching. */
    var infoReady = (!window.customElements || customElements.get('product-info'))
      ? Promise.resolve()
      : Promise.race([
          customElements.whenDefined('product-info'),
          new Promise(function (resolve) { setTimeout(resolve, 1500); })
        ]);
    infoReady.then(function () { setTimeout(redirectSoldOutLanding, 0); });
    refresh();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-radios, variant-selects, .product-form__input')) {
        if (e.isTrusted) ccUserPicked = true;
        if (!ccSwapping) {
          var note = document.querySelector('.cc-swap-note');
          if (note) note.remove();
        }
        setTimeout(refresh, 60);
      }
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(refresh, 50); });
    }
    setInterval(updateStock, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
